import { render, staticRenderFns } from "./VTurnover.vue?vue&type=template&id=1be8c9c8&"
import script from "./VTurnover.vue?vue&type=script&lang=js&"
export * from "./VTurnover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports